import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Heading from './Heading'
import { reset } from '../organizationsManagementSlice'
import { OuterContainer } from '@/containers/OrganizationsManagement/styled-components'

const Index = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(reset())
  }, [])

  return (
    <OuterContainer>
      <Heading />
    </OuterContainer>
  )
}

export default Index
